import { useAdmin } from '@/api/partners/admins/use-admin';
import { EVFMC_ORG_ID } from '@/core/organization/use-current-organization';

// Gates the Eon One Customers area: only admins that belong to an organization
// can see the sidebar item and the /partner/customers route. Plain customers
// and org-less admins get a 401/403 / organization: null from
// v2/internal/partners/admins/me.
export const useHasOrganization = () => {
  const { data: admin, isPending } = useAdmin();

  return {
    hasOrganization: !!admin?.organization,
    organization: admin?.organization,
    isEVFMC: admin?.organization?.id === EVFMC_ORG_ID,
    // Gates the full Eon One dashboard (ENG-751): eonOneTutorialCompletedAt
    // lives on the organization, so this is falsy whenever there's no org too.
    canUseEonOne: !!admin?.organization?.eonOneTutorialCompletedAt,
    isPending,
  };
};
